import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b67428d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2b67428d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67428d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b67428d')) {
      api.createRecord('2b67428d', component.options)
    } else {
      api.reload('2b67428d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b67428d&scoped=true", function () {
      api.rerender('2b67428d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Operations/workerTrack/index.vue"
export default component.exports